<div class="catalog-mobile-filter" *ngIf="isOpen">
  <div class="catalog-mobile-filter__header">
    <span class="catalog-mobile-filter__title" i18n="@@Filter">Фильтр товаров</span>
    <button class="catalog-mobile-filter__close" type="button" (click)="close()" aria-label="Закрыть">
      <nb-icon icon="close-outline"/>
    </button>
  </div>

  <div class="catalog-mobile-filter__body">
    <app-filter [filter]="filter"/>
  </div>
</div>
